import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';

// Providers-Services
import { ApiRestService } from '../services/shared/api-rest.service';
import { NotifyService } from './shared/notify.service';

// import tablas
import { table } from '../components/shared/tables';


@Injectable({
  providedIn: 'root'
})
export class DteService {

  constructor(
    private http: HttpClient,
    private _apiRestService: ApiRestService,
    public _notifyService: NotifyService
  ) { }

  // Consulta todas las ordenes  de compra activas
  /*
  public getDTEs(opt?) {
    let path;

    path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"uri":"${opt}"}}`

    //if (opt === 'val') {
    //  path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"Etapa":"Validada"}}`
    //}
    //else {
    //  path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}"}`
    //}
    // return this.http.get('assets/data/pruebaoc.json') // return res si se va a probar
    return this.http.get(path)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res }
          return dataUser
        }));
  }
*/
/*
// Consulta OC por prnt
  public getDTE(prnt, type) {
    let path
    if (type === 'old') {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.ocarOldr}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    }
    else {
      path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.ocar}","type":"${table.type.metaExtn}","objc":{"prnt":"${prnt}"}}`;
    }

    return this.http.get(path)
      .pipe(map
        ((res: Response) => {
          return res;
        }));
  }
*/


// llamada multicampo
// http://localhost:4200/srvc/6/%7B%22tble%22:%22facturas%22,%22objc%22:%7B%22oc%22:%22721703-189-AG24%22,%22emisor%22:%2277.307.196-9%22%7D%7D

  // Consulta DTE por OC
  public getDTE(oc: any, rut: any){ //
    let path
    path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"oc":"${oc}"}}`;
    //console.log('RUT getDTE' + rut );
    return this.http.get(path)
    .pipe(

      map((res: Response) => {
          let dataUser = { data: res }
          
          if ( dataUser!==undefined && dataUser.data!==undefined  ){
            console.log ( "Largo dataUser.data: " + Object.keys( dataUser.data ).length );
            //console.log( dataUser.data );
          }
          else
            console.log ( "No hay definicion para dataUser o dataUser.data"); 

          if ( dataUser!==undefined && dataUser.data!==undefined && Object.keys( dataUser.data ).length > 0 ){
            return dataUser;
          }
          else{
            console.log("Obteniendo getDTExEMISOR");
            return this.getDTExEMISOR(rut);
          }
      }), 

      catchError(error => {
        console.log("Obteniendo getDTExEMISOR catchError: " + error.message);
        return this.getDTExEMISOR(rut);
      }),

    );
  }

  // Consulta DTE por RUT Emisor
  public getDTExEMISOR(rut){ //
    let path

    path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"emisor":"${rut}"}}`;

    return this.http.get(path)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res }
          console.log ( "getDTExEMISOR -> Largo dataUser.data: " + Object.keys( dataUser.data ).length );
          console.log( dataUser.data );
          return dataUser;
        }));
  }


  // Consulta DTE por RUT
  public getDTExRUT(rut){ //
    let path

    path = this._apiRestService.APIURL.serv6 + `/{"tble":"${table.facturas}","objc":{"rut":"${rut}"}}`;

    return this.http.get(path)
      .pipe(map
        ((res: Response) => {
          return res;
        }));
  }

  // Consulta DTE por OC
  public registraDTE(url: any){ //
    let path
    //path = this._apiRestService.APIURL.serv8 + `/{"tble":"${table.accesodte}","prnt":"1","objc":{"url":${JSON.stringify(url)}}}`;
    path = this._apiRestService.APIURL.serv203 + `/{"url":"${url}"}`;

    return this.http.get(path)
    .pipe(map
      ((res: Response) => {
        let dataUser = { data: res }
        return dataUser
      }));
  }

/*
  // Editar OC con Objero
  public updateOc(prnt, oc) {
    let objStr = JSON.stringify(oc);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    //  console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }));
  }
*/

/*
  // Editar OC con string
  public updateOcStrg(prnt, Saldo, montoOc?, anio?) {
    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"Saldo":${JSON.stringify(Saldo)}}}`);
    //return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"Saldo":${JSON.stringify(Saldo)}}}`
    let montoAnio;
    if (anio === 1) {
      montoAnio = "montoAnio1";
    }
    else if (anio === 2) {
      montoAnio = "montoAnio2";
    }
    else if (anio === 3) {
      montoAnio = "montoAnio3";
    }
    else if (anio === 4) {
      montoAnio = "montoAnio4";
    }

    // console.log(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"${montoAnio}":${JSON.stringify(Saldo)},"Saldo":${JSON.stringify(montoOc)}}}`);
    return this.http.get(this._apiRestService.APIURL.serv8 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"${montoAnio}":${JSON.stringify(Saldo)},"Saldo":${JSON.stringify(montoOc)}}}`
    ).pipe(
      map(
        (res: any) => {
          return res;
        }));
  }
*/

/*
  // Eliminar atributo de la OC, para actualizar. con objeto
  deleteOcAtrb(prnt, obj) {
    let objStr = JSON.stringify(obj);
    objStr = objStr.replace(/\//g, 'þ');
    objStr = objStr.replace(/&/g, '¬');
    //  console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":${objStr}}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":${objStr}}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }
*/


/*
  // Eliminar atributo de la OC, para actualizar. con string (Saldo)
  deleteOcAtrbStrg(prnt, Saldo, SaldoOc?, anio?) {
    //  console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"Saldo":${JSON.stringify(Saldo)}}}`);
    // return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"Saldo":${JSON.stringify(Saldo)}}}`
    let montoAnio;
    if (anio === 1) {
      montoAnio = "montoAnio1";
    }
    else if (anio === 2) {
      montoAnio = "montoAnio2";
    }
    else if (anio === 3) {
      montoAnio = "montoAnio3";
    }
    else if (anio === 4) {
      montoAnio = "montoAnio4";
    }

    // console.log(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"${montoAnio}":${JSON.stringify(Saldo)}, "Saldo":${JSON.stringify(SaldoOc)}}}`);
    return this.http.get(this._apiRestService.APIURL.serv9 + `/{"tble":"${table.ocar}","prnt":"${prnt}","objc":{"${montoAnio}":${JSON.stringify(Saldo)}, "Saldo":${JSON.stringify(SaldoOc)}}}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Cerrar OC, envia oc a tabla old
  cerrarOc(prnt) {
    // console.log(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.ocar}","prnt":"${prnt}","type":"${table.type.toOld}"}`);
    return this.http.get(this._apiRestService.APIURL.serv10 + `/{"tble":"${table.ocar}","prnt":"${prnt}","type":"${table.type.toOld}"}`
    ).pipe(
      map(
        (res: any) => {
          let data = res;
          return data;
        }));
  }

  // Consulta de todos las ordenes de compra cerradas
  public getOcsCerradas() {
    // return this.http.get('assets/data/pruebaoc.json') // return res si se va a probar
    return this.http.get(this._apiRestService.APIURL.serv6 + `/{"tble":"${table.ocarOldr}"}`)
      .pipe(map
        ((res: Response) => {
          let dataUser = { data: res }
          return dataUser;
        }));
  }

  // Cargar OC manualmente
  public loadOc(oc: string) {
    return this.http.get(`${this._apiRestService.APIURL.serv194}/${oc}`)
      .pipe(map
        ((res: any) => {
          let data = res;
          return data;
        }));
  }

  public validarOC(oc: string){
    console.log(oc);
    if (/([0-9]{1,})+\-([0-9]{1,})+(\-[a-zA-Z\-0-9]{1,})+?$/.test(oc)) {
      return false;
    }else{
      return true;
    }
  }
*/

}
